import React, { useEffect, useState } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';

import Star from '@material-ui/icons/Star';

import { getBookmarks } from '../services/storageService'

export default function Bookmarks(props) {

    const [bookmarks, setBookmarks] = useState([])
    useEffect(() => {
        setBookmarks(getBookmarks())
    }, [])

    const redirectToItemView = (item) => {
        if(item.isRepository)
            props.history.push(`/item-repository/${item.id}`)
        else
            props.history.push(`/item/${item.id}`)
    }

    return (
        <Box flexGrow={1}>
            {!bookmarks.length &&
                <Box mt={2}>
                    <Typography align="center" variant="subtitle1" color="primary">
                        Você ainda não salvou nenhum favorito
                    </Typography>
                </Box>
            }
            <List>
                {bookmarks.map((item, index) =>
                    <ListItem button 
                        key={item.id}
                        divider={true} 
                        onClick={() => redirectToItemView(item)}>
                        <ListItemAvatar>
                            <Avatar>
                                <Star />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={item.title} secondary={item.author} />
                    </ListItem>
                )}
            </List>
            <Box display="flex" p={1} justifyContent="center">
                <Button 
                    color="primary" 
                    fullWidth={true}
                    onClick={() => props.history.goBack()}>
                        Voltar
                </Button>
            </Box>
        </Box>
    );
}